import { getBaseUrl, request } from 'src/helper/api';

// Get vendors list
export const getVendors = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/getVendors',
  );
export const getVendorDetails = (token?: string, vendorId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors/${vendorId}`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/getVendorDetails',
  );
// B14: what Landon already applies to one vendor (read-only). `vendorId` is the vendor's uuid.
export const getVendorLandonRules = (token?: string, vendorId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors/${vendorId}/landon-rules`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/getVendorLandonRules',
  );
export const updateVendorStatus = (token?: string, vendorId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/vendors/${vendorId}/actions/updateStatus`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/updateVendorStatus',
  );

export const resendOnboardingLink = (token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/generate-signed-url`,
      contentType: 'json',
      token,
    },
    'vendors/resendOnboardingLink',
  );

export const approvedUnderReview = (token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-status`,
      contentType: 'json',
      token,
    },
    'vendors/setStatus',
  );

// GET api/vendor-work-approvals?work_approval=pending — imported vendors waiting for a person to
// switch them on (6.11), in the server's suggested order. The query rides in the dispatched payload.
export const getVendorWorkApprovals = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendor-work-approvals`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/getVendorWorkApprovals',
  );

// PATCH api/vendors/{vendor}/work-approval — body { work_approval: 'approved' | 'declined',
// trade_uuids?: [...] }. `trade_uuids` only with 'approved': the trades the person confirmed (6.12).
// Returns the updated row; 422 carries the server's message.
export const updateVendorWorkApproval = (
  token?: string,
  vendorUuid?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/vendors/${vendorUuid}/work-approval`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/updateVendorWorkApproval',
  );
